import {
  dimensiondata_1_tetelek_group_w200_row,
  year_column_expanded,
  month_column,
  millio_kobmeter_value_1_data_precision,
  terajoule_netto_value_2_data_precision,
  terajoule_brutto_value_3_data_precision,
  gigawatt_ora_value_4_data_precision,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const haviFoldgazMerlegConfig: PivotGridConfig = {
  showChart: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/HaviFoldgazMerleg',
      select: ['date', 'dimension_1', 'value_1', 'value_2', 'value_3', 'value_4'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_w200_row,
      year_column_expanded,
      month_column,
      millio_kobmeter_value_1_data_precision,
      terajoule_netto_value_2_data_precision,
      terajoule_brutto_value_3_data_precision,
      gigawatt_ora_value_4_data_precision,
      order_1,
      order_2
    ],
  },
};
